import React, {Component} from 'react';
import {any, arrayOf, bool, func, node} from 'prop-types';
import ResizableTextArea from './ResizableTextArea';
import If from '../../misc/If';

import './TextArea.css';

class TextArea extends Component {
  static propTypes = {
    autoSize     : bool,
    errors       : arrayOf(node),
    hint         : node,
    label        : any,
    onPressEnter : func,
    onResize     : func,
    value        : any
  };

  static defaultProps = {
    errors : [],
    hint   : null,
    label  : null
  };

  constructor(props) {
    super(props);

    this.resizableTextArea = null

    const value = typeof props.value === 'undefined' ? props.defaultValue : props.value;

    this.state = {
      value
    };
  }

  static getDerivedStateFromProps(nextProps) {
    if ('value' in nextProps) {
      return {
        value : nextProps.value
      };
    }

    return null;
  }

  setValue(value, callback: () => void) {
    if (!('value' in this.props)) {
      this.setState({value}, callback);
    }
  }

  focus = () => {
    this.resizableTextArea.textArea.focus();
  };

  blur() {
    this.resizableTextArea.textArea.blur();
  }

  saveTextArea = resizableTextArea => {
    this.resizableTextArea = resizableTextArea;
  };

  handleChange = event => {
    const {onChange} = this.props;

    this.setValue(event.target.value, () => {
      this.resizableTextArea.resizeTextarea();
    });

    onChange(event.target.value);
  };

  handleKeyDown = event => {
    const {onPressEnter, onKeyDown} = this.props;

    if (event.keyCode === 13 && onPressEnter) {
      onPressEnter(event);
    }

    if (onKeyDown) {
      onKeyDown(event);
    }
  };

  render() {
    const {errors, hint, label, ...restProps} = this.props;

    return (
      <div className="textarea__wrapper">
        <If condition={Boolean(label)}>
          <label className="textarea__label">
            {label}
          </label>
        </If>

        <ResizableTextArea
          {...restProps}
          onKeyDown={this.handleKeyDown}
          onChange={this.handleChange}
          ref={this.saveTextArea}
        />

        <If condition={Boolean(hint)}>
          <p
            className="textarea__hint"
            dangerouslySetInnerHTML={{
              __html : hint
            }}
          />
        </If>

        <If condition={errors.length > 0}>
          <p className="textarea__error">
            {errors[0]}
          </p>
        </If>

        <If condition={errors.length === 0}>
          <p className="textarea__error_hidden">
            error
          </p>
        </If>

      </div>
    );
  }
}

export default TextArea;
